<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor"><i class="fa fa-cart-flatbed text-secondary"></i> Recoger preparación:</h3>
        <h3 class="text-themecolor">

            <img *ngIf="campanya.campanyaTipo === '1 a 1'"
                 src="../../../assets/images/icon/1a1.png"
                 height="30px"
                 alt="1 a 1"
                 class="mr-1">
            {{recogida_cod}} ({{currentIndex+1}} / {{totalUbis}})
        </h3>

        <h4 *ngIf="registroActual.uic"> <label class="form-control-label">
                <i>Uic: </i><i class="fa-solid fa-dolly"></i> {{registroActual.uic}}</label>
        </h4>
    </div>
</div>

<div class="row animated fadeIn fast">
    <div class="col-lg-12">
        <div class="card">


            <div class="card-body">

                <form class="form p-t-20"
                      [formGroup]="formRec"
                      (ngSubmit)="enviar()"
                      class="form-horizontal">



                    <!-- PRIMERA  parte del form, pedir uic -->
                    <div class="row"
                         *ngIf="!registroActual.uic">


                        <!-- uic -->
                        <div class="col-md-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['uic'].errors }">
                                <label class="form-control-label">UIC: <b>{{registroActual.uic}}</b></label>

                                <div class="input-group">

                                    <div *ngIf=" f['uic'].value"
                                         class="input-group-prepend pointer">
                                        <button class="btn btn-outline-secondary"
                                                (click)="limpiaUic()"
                                                type="button">
                                            <i class="fa-regular fa-trash-can fa"
                                               aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <input type="text"
                                           #uicInput
                                           formControlName="uic"
                                           class="form-control"
                                           trim="blur"
                                           (keydown.enter)="onUicEnter($event)"
                                           autofocus
                                           (focus)="uicInput.select()"
                                           [ngClass]="{ 'form-control-danger': enviado && f['uic'].errors }">

                                    <div *ngIf=" f['uic'].value"
                                         class="input-group-append">
                                        <button class="btn btn-outline-secondary"
                                                (click)="saltaUic(uicInput)"
                                                type="button"
                                                id="button-addon2"><i class="fa-solid fa-check"></i></button>
                                    </div>

                                </div>

                                <div *ngIf="enviado && f['uic'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['uic'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['uic'].errors['formatoIncorrecto']">Formato incorrecto</div>

                                    <div *ngIf="formRec.get('uic')?.errors?.['apiError']">
                                        {{formRec.get('uic')?.errors?.['apiError'] }}
                                    </div>

                                </div>


                            </div>
                        </div>

                    </div> <!-- row -->





                    <!-- SEGUNDA  parte del form se mostrará si existe uic pero aún NO hay Ubicación -->


                    <div class="row"
                         *ngIf="(formRec.get('uic')?.value == registroActual?.uic) && (formRec.get('ubicacion')?.value !== registroActual?.ubicacion)">


                        <!-- <div class="row"> -->
                        <div class="col-md-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['ubicacion'].errors }">
                                <label class="form-control-label"
                                       style="white-space: nowrap;">
                                    Ubicación:
                                    <!-- Mostrar la ubicación con los 2, 3 y 4º pares destacados -->
                                    <b>
                                        {{registroActual.ubiFormat.slice(0, 3)}}
                                        <span class="ubiDestacado">
                                            {{registroActual.ubiFormat.slice(3, 11)}}
                                        </span>
                                        {{registroActual.ubiFormat.slice(11)}}
                                    </b>
                                </label>

                                <div class="input-group">
                                    <div class="input-group-prepend pointer">
                                        <button class="btn btn-outline-secondary"
                                                (click)="buscaUbicacionAlternativa()"
                                                type="button">
                                            <i class="fa-regular fa-compass fa-xl"></i>
                                        </button>
                                    </div>
                                    <input type="text"
                                           formControlName="ubicacion"
                                           id="ubicacion"
                                           class="form-control"
                                           trim="blur"
                                           (keydown.enter)="onUbicacionEnter($event)"
                                           [ngClass]="{ 'form-control-danger': enviado && f['ubicacion'].errors }">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary"
                                                (click)="saltaUbicacion()"
                                                type="button"
                                                id="button-addon2"><i class="fa-solid fa-check"></i></button>
                                    </div>


                                </div>
                                <div *ngIf="enviado && f['ubicacion'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['ubicacion'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['ubicacion'].errors['noValido']">No es la ubicación correcta</div>
                                </div>
                            </div>
                        </div>

                    </div>



                    <!-- Tercera  parte del form que se mostrará si ubicacion es igual a registroActual.ubicacion -->

                    <div class="row"
                         *ngIf="formRec.get('ubicacion')?.value === registroActual?.ubicacion">


                        <div class="col-md-4">
                            <h4 class="card-title">
                                <button class="btn btn-outline-secondary"
                                        (click)="buscaUbicacionAlternativa()"
                                        type="button">
                                    <i class="fa-regular fa-compass "></i>
                                </button>
                                Ubicación: <b>{{registroActual.ubiFormat}}</b>
                            </h4>
                            <h4 class="card-title">EAN: <b>{{registroActual.ean}}</b></h4>
                            <h4 class="card-title text-muted">SKU: <b>{{registroActual.sku}}</b></h4>

                            <div *ngIf="registroActual.foto != '_noFoto.png'"
                                 class="text-center">
                                <img [src]="fotoDir +'/articulos' + imgResized + registroActual.foto"
                                     loading="lazy"
                                     alt="Foto"
                                     class="img-thumbnail mx-auto"
                                     style="max-width: 35% !important;"
                                     title="foto">
                            </div>

                            <h4 class="card-subtitle"><b>{{registroActual.descripcion}}</b></h4>

                            <div class="row border mb-1 p-1">
                                <div class="col-4 mt-2 text-right">
                                    <h6 class="card-subtitle">Cantidad pedida:</h6><b class="font-larger">{{registroActual.cant_reserva | number: '0.0-0':'es'}}</b>
                                </div>
                                <div class="col-4 mt-2 text-right">
                                    <h6 class="card-subtitle">Cantidad recogida:</h6><b class="font-larger text-info">{{registroActual.cant_recogida | number: '0.0-0':'es'}}</b>
                                </div>
                                <div class="col-4 mt-2 text-right">
                                    <h6 class="card-subtitle">Stock en ubicación:</h6><b class="font-larger">{{registroActual.stockUbi | number: '0.0-0':'es'}}</b>
                                </div>
                            </div>

                            <div class="row border mb-1 p-1">

                                <!-- cant_alCarro -->
                                <div class="col-4"
                                     [ngClass]="{ 'has-danger':f['cant_alCarro'].errors }">
                                    <label class="form-control-label">Cantidad:</label>
                                    <input type="text"
                                           formControlName="cant_alCarro"
                                           [readonly]="cantidadInfo !== ''"
                                           id="cant_alCarro"
                                           class="form-control"
                                           trim="blur"
                                           [ngClass]="{ 'form-control-danger': f['cant_alCarro'].errors }">

                                    <div *ngIf="f['cant_alCarro'].errors"
                                         class="form-control-feedback">
                                        <div *ngIf="f['cant_alCarro'].errors['required']"></div>
                                        <div *ngIf="f['cant_alCarro'].errors['cantidadInvalida']">Max. {{registroActual.cant_reserva - registroActual.cant_recogida | number: '0.0-0':'es'}}</div>
                                    </div>
                                </div>

                                <!-- ean -->
                                <div class="  col-8"
                                     [ngClass]="{ 'has-danger': f['ean'].errors }">
                                    <label class="form-control-label">EAN: <b>{{registroActual.ean}}</b></label>

                                    <div class="input-group">
                                        <input type="text"
                                               formControlName="ean"
                                               id="ean"
                                               class="form-control"
                                               autocomplete="off"
                                               inputmode="numeric"
                                               pattern="[0-9]*"
                                               maxlength="13"
                                               (keydown.enter)="onEanEnter($event)"
                                               [ngClass]="{ 'form-control-danger': f['ean'].errors }">

                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary"
                                                    (click)="saltaEan()"
                                                    type="button"
                                                    id="button-addon2"><i class="fa-solid fa-check"></i></button>
                                        </div>
                                    </div>
                                    <div *ngIf="f['ean'].errors"
                                         class="form-control-feedback">
                                        <div *ngIf="f['ean'].errors['required']">Campo obligatorio</div>
                                        <div *ngIf="f['ean'].errors['formatoIncorrecto']">Formato incorrecto (máximo 13 caracteres)</div>
                                        <div *ngIf="f['ean'].errors['noCoincide']">El EAN no coincide con el esperado</div>
                                    </div>
                                </div>


                                <!-- cant_cajas -->
                                <div *ngIf="campanya.campanyaTipo === '1 a 1' && cantidadInfo===''"
                                     class="col-4"
                                     [ngClass]="{ 'has-danger':f['cant_cajas'].errors }">
                                    <label class="form-control-label">Cajas:</label>
                                    <input type="text"
                                           formControlName="cant_cajas"
                                           id="cant_cajas"
                                           class="form-control"
                                           trim="blur"
                                           [ngClass]="{ 'form-control-danger': f['cant_cajas'].errors }">


                                    <div *ngIf="f['cant_cajas'].errors"
                                         class="form-control-feedback">
                                        <div *ngIf="f['cant_cajas'].errors['cantidadInvalida']"></div>
                                    </div>
                                </div>

                                <!-- cant_cajas_unidades -->
                                <div *ngIf="campanya.campanyaTipo === '1 a 1' && cantidadInfo===''"
                                     class="col-8"
                                     [ngClass]="{ 'has-danger':f['cant_cajas_unidades'].errors }">
                                    <label class="form-control-label">Unidades por caja:</label>
                                    <div class="input-group">
                                        <input type="text"
                                               formControlName="cant_cajas_unidades"
                                               id="cant_cajas_unidades"
                                               class="form-control"
                                               trim="blur"
                                               [ngClass]="{ 'form-control-danger': f['cant_cajas_unidades'].errors }">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary"
                                                    (click)="cant_cajasOut()"
                                                    type="button"
                                                    id="button-addon2"><i class="fa-solid fa-check"></i></button>
                                        </div>

                                        <div *ngIf="f['cant_cajas_unidades'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['cant_cajas_unidades'].errors['cantidadInvalida']"></div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="cantidadInfo"
                                     class="col-12 mb-2">
                                    <div class="input-group">
                                        <div class="form-control text-right bg-light h-auto text-secondary"
                                             [innerHTML]="cantidadInfo"></div>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary"
                                                    (click)="cancel_cant_cajas()"
                                                    type="button">
                                                <i class="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>






                                <!-- cajasCalculadas -->
                                <div *ngIf="cajasCalculadas > 0"
                                     class="col-12 pb-2">
                                    <div class="input-group">
                                        <button class="btn mr-2"
                                                [ngClass]="cajasEscogidas ? 'btn-info' : 'btn-outline-secondary'"
                                                (click)="enviaCajas()"
                                                type="button"
                                                id="button-addon2"><i class="fa-solid fa-box-archive"></i></button>
                                        <span class="input-group-text"
                                              [ngClass]="cajasEscogidas ? 'text-info' : 'text-secondary'">{{cajasCalculadas | number: '0.0-0':'es'}} Cajas de {{registroActual.unidadesCaja | number: '0.0-0':'es'}} unidades ({{cajasCalculadas * registroActual.unidadesCaja | number: '0.0-0':'es'}} uds)</span>
                                    </div>
                                </div>

                            </div> <!-- row border mb-1 -->


                        </div> <!-- col-md-4 -->


                    </div>




                    <div *ngIf="registroActual.uic"
                         class="row mt-2">

                        <div class="col-6">
                            <button [disabled]="loading"
                                    type="button"
                                    (click)="carroLlenoClick()"
                                    class="btn waves-effect waves-light btn-rounded btn-success btn-sm">
                                <i *ngIf="loading"
                                   class="fa fa-spinner fa-spin"></i>
                                Carro lleno</button>


                            <button [disabled]="loading"
                                    type="button"
                                    (click)="volverClick()"
                                    class="ml-1 btn waves-effect waves-light btn-rounded btn-secondary btn-sm">
                                <i *ngIf="loading"
                                   class="fa fa-spinner fa-spin"></i>
                                Volver</button>
                        </div>


                        <div *ngIf="formRec.get('ubicacion')?.value === registroActual?.ubicacion"
                             class="col-6 text-right">
                            <div class="input-group">
                                <select class="custom-select form-control-sm"
                                        formControlName="saltar"
                                        id="saltar">
                                    <option value="Falta stock">Falta stock</option>
                                    <option value="Stock dañado">Stock dañado</option>
                                    <option value="Sin acceso">Sin acceso</option>
                                    <option value="Otros">Otros</option>
                                </select>
                                <div class="input-group-append">
                                    <button type="button"
                                            class="btn waves-effect waves-light btn-outline-secondary btn-sm"
                                            (click)="saltarArticuloClick()"
                                            data-dismiss="modal">
                                        <i *ngIf="loading"
                                           class="fa fa-spinner fa-spin"></i>Saltar</button>
                                </div>
                            </div>
                        </div>




                        <div class="col-6 text-right"
                             *ngIf="formRec.get('ubicacion')?.value !== registroActual?.ubicacion">
                            <button [disabled]="loading"
                                    type="button"
                                    (click)="cerrarPreparacion()"
                                    class="btn waves-effect waves-light btn-rounded btn-warning btn-sm">
                                <i *ngIf="loading"
                                   class="fa fa-spinner fa-spin"></i>
                                Cerrar</button>
                        </div>





                    </div> <!-- row -->






                </form>
            </div>
        </div>


        <!-- 
            <div class="row">
                <pre>
                    registroActual: {{ registroActual | json }} 
                    formRec: {{ formRec.value | json }} 
                </pre>
            </div> 
        -->



    </div>
</div>





<!-- Resumen de la preparación -->


<div class="col-lg-12"
     style="padding: 1px">

    <div class="card"
         *ngFor="let uic of getPreparacionesAgrupadasKeys()">

        <!-- Articulos recogidos -->
        <span *ngIf="uic!='Incidencias'">

            <div class="card-body border rounded">

                <h5 class="text-success"> <i class="fa-solid fa-dolly"></i> {{ uic }}</h5>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>EAN</th>
                            <th>Sku</th>
                            <th class="text-right">Cant.</th>
                            <th class="text-right">Recg.</th>
                            <th>Ubicación</th>
                        </tr>
                    </thead>
                    <tbody class="fs-10">
                        <tr *ngFor="let recPrep of preparacionesAgrupadas[uic]"
                            [ngClass]="{'bg-warning': recPrep.estado=='8'}">
                            <td>{{ recPrep.ean }}</td>
                            <td>{{ recPrep.sku }}</td>
                            <td class="text-right">
                                <ng-container *ngIf="recPrep.cant_inicial == 0">
                                    {{ recPrep.cant_reserva | number: '0.0-0':'es' }}
                                </ng-container>
                                <ng-container *ngIf="recPrep.cant_inicial != 0">
                                    {{ recPrep.cant_inicial | number: '0.0-0':'es' }}
                                </ng-container>
                            </td>
                            <td class="text-right"
                                [ngClass]="{
                            'bg-blue': recPrep.estado === Constantes.ESTADO_PREPARACION_EMPEZADO,
                            'bg-green': recPrep.estado ===  Constantes.ESTADO_PREPARACION_COMPLETADA
                         }">{{ recPrep.cant_recogida | number: '0.0-0':'es' }}</td>
                            <td class="monospace"> {{ recPrep.ubicacion! | mask: '00.00.00.00.00.00' }}</td>
                        </tr>
                    </tbody>
                </table>

            </div> <!-- card-body -->
        </span>


        <!-- Artúculos pendientes -->
        <span *ngIf="uic=='Incidencias'">
            <details open>
                <summary>Ubicaciones pendientes</summary>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>EAN/<span class="text-muted fs-12">SKU · <small>Descripción</small></span></th>
                            <th class="text-right">Cantidad</th>
                            <th>Ubicación</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let recPrep of preparacionesAgrupadas[uic]">
                            <tr class="align-middle"
                                [ngClass]="{'bg-warning': recPrep.estado=='8'}">
                                <td>{{ recPrep.ean }}</td>
                                <td class="text-right">
                                    <ng-container *ngIf="recPrep.cant_inicial == 0">
                                        {{ recPrep.cant_reserva | number: '0.0-0':'es' }}
                                    </ng-container>
                                    <ng-container *ngIf="recPrep.cant_inicial != 0">
                                        {{ recPrep.cant_inicial | number: '0.0-0':'es' }}
                                    </ng-container>
                                </td>
                                <!-- <td class="monospace">{{ recPrep.ubicacion! | mask: '00.00.00.00.00.00' }}</td> -->

                                <td class="monospace"
                                    [innerHTML]="formatUbicacion(recPrep.ubicacion!)"
                                    [ngClass]="{'bg-warning': recPrep.estado=='8'}"></td>
                            </tr>
                            <tr [ngClass]="{'bg-warning': recPrep.estado=='8'}"
                                class="fila-desc">
                                <td colspan="3"
                                    class="text-muted fs-12 pt-0"><span class="text-muted fs-12">{{ recPrep.sku }}</span> · <small>{{ recPrep.descripcion }}</small></td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </details>
        </span>

    </div>



    <!-- Cajas recogidas -->
    <span *ngIf="cajasRecogidas.length > 0">
        <div class="card">

            <div class="card-body border rounded">

                <h5 class="text-info"> <i class="fa-solid fa-box"></i> Cantidades recogidas por cajas</h5>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>UIC</th>
                            <th>EAN</th>
                            <th class="text-right">Por caja</th>
                            <th class="text-right">Cajas</th>
                            <th class="text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody class="fs-10">
                        <ng-container *ngFor="let rec of cajasRecogidas; let i = index">
                            <tr *ngIf="i > 0 && rec.uic !== cajasRecogidas[i-1].uic">
                                <td colspan="5"
                                    class="p-0">
                                    <hr class="m-0 border-dark">
                                </td>
                            </tr>
                            <tr>
                                <td>{{ rec.uic }}</td>
                                <td>{{ rec.ean }}</td>
                                <td class="text-right">{{ rec.cant_cajas_unidades | number: '0.0-0':'es' }}</td>
                                <td class="text-right">{{ rec.cajas | number: '0.0-0':'es' }}</td>
                                <td class="text-right"> <b>{{ rec.cajas * rec.cant_cajas_unidades | number: '0.0-0':'es' }}</b></td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

            </div> <!-- card-body -->
        </div> <!-- card -->
    </span>


</div>